<div mat-dialog-title>
    Update Order Status
</div>
<mat-dialog-content>
    <div class="mat-body-1">
        <div>
            <span class="label">Order #:</span>
            <span class="value">{{order.order_number}}</span>
        </div>
        <div>
            <span class="label">Email:</span>
            <span class="value">{{order.email}}</span>
        </div>
        <div class="label">Status:</div>
        <mat-radio-group [value]="order.status" (change)="statusChanged($event)">
            <mat-radio-button value="processing">Processing</mat-radio-button>
            <mat-radio-button value="fulfilling">Fulfilling</mat-radio-button>
            <mat-radio-button value="shipped">Shipped</mat-radio-button>
            <mat-radio-button value="delivered" class="bottom_sep">Delivered</mat-radio-button>
            <mat-radio-button value="canceled">Canceled</mat-radio-button>
            <mat-radio-button value="external" class="bottom_sep">External</mat-radio-button>
        </mat-radio-group>

        <mat-checkbox [(ngModel)]="sendEmail"
                      [disabled]="!statusHasEmail()">Send notification email</mat-checkbox>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button
            color="primary"
            type="button"
            [disabled]="!newStatus"
            (click)="update()">Update</button>
    <button mat-raised-button
            mat-dialog-close
            type="button">Cancel</button>
</mat-dialog-actions>

